import React from 'react';
import CommunityFeed from '../../components/community/CommunityFeed';
import CommunityHighlights from '../../components/community/CommunityHighlights';

export default function FeedPage() {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: 16 }}>
      <CommunityHighlights />
      <CommunityFeed />
    </div>
  );
}
